import React, { useEffect, useRef } from 'react';
import { runtime, Util } from 'codeArt/common';
import ReactEcharts from "echarts-for-react";
import { theme } from 'codeArt/components/Base';
import * as echarts from "echarts";
import { depleteId } from 'app/routes/analysis/routes/cost/constant';

export default class ScatterChart extends React.Component {

    constructor(props) {
        super(props);
    }


    handle(v) {
        let axis = { ...v }
        let format = v.format; let label = v.label;
        delete axis.format; delete axis.label;
        return { axis: axis, format: format, label: label }
    }

    getOption() {
        let { data, y: yAxis, x: xAxis, title, tooltip, tooltipFormat, line, grid, titleStyle, lineColor } = this.props;
        let { x, y } = data; let option = {}; let my = this;

        if (title) {
            option.title = {
                text: title,
                textStyle: {
                    fontSize: 16,
                    fontWeight: 400,
                    color: theme.color.dark
                    , ...titleStyle
                }
            }
        }

        if (tooltip) {
            option.tooltip = {
                trigger: 'item',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: function (params) {
                    let data = tooltipFormat ? tooltipFormat({ value: params.data, name: params.seriesName }) : { value: params.data[1], name: params.seriesName };
                    let tip = `${params.marker}${data.name} : ${data.value}`;
                    return tip;
                }
            }
        }

        let xParams = my.handle(xAxis);
        option.xAxis = {
            type: "value",
            data: x,
            splitLine: { show: line, lineStyle: { color: lineColor } }, //网格线是否显示 
            axisLabel: {
                formatter: function (value) {
                    return xParams.format ? xParams.format(value) : value;
                },
                ...xParams.label
            },
            ...xParams.axis
        };

        let yParams = my.handle(yAxis);
        option.yAxis = {
            type: "value",
            splitLine: { show: line, lineStyle: { color: lineColor } }, //网格线是否显示 
            axisLabel: {
                formatter: function (value) {
                    return yParams.format ? yParams.format(value) : value;
                },
                ...yParams.label
            },
            ...yParams.axis
        };



        option.grid = { left: '10', right: '25', containLabel: true }; //自定义图表两边留空
        option.grid = Object.assign(option.grid, grid);


        let series = y.map((t, i) => {
            let serie = {
                name: t.name,
                type: 'scatter',
                symbol: 'circle',
                symbolSize: t.size || 10,
                color: t.color,
                data: t.data,
            }

            return serie;
        })


        option.series = series;
        return option;
    }

    getEvents() {
        let { onClick } = this.props;
        if (!onClick) return {};
        return { 'click': onClick };
    }

    render() {
        return <ReactEcharts option={this.getOption()} notMerge={true} lazyUpdate={true} className={"w-100 h-100"} onEvents={this.getEvents()} />
    }
}

ScatterChart.defaultProps = {
    title: "",
    grid: {},
    tooltip: true,
    line: false,
    y: {},
    x: {},
    lineColor: "#f0f0f0",
}

ScatterChart.propTypes = {
};


